<template>
	<div>
		<div v-if="loading" class="py-5 text-center">
			<Spinner type="primary">{{ $t('general.loading') }}</Spinner>
		</div>
		<div v-else-if="attachments.length">
			<Select
				v-if="attachments.length > 1"
				v-model="selection"
				:label="`${$t('general.select-attachment')}:`"
				:options="attachmentOptions"
			/>
			<div v-else class="mb-4">
				<h5 class="font-bold">{{ attachments[0].name }}</h5>
			</div>
			<div v-if="selectedAttachment" class="text-center">
				<iframe
					:src="selectedAttachment.url"
					:title="
						selectedAttachment.name || $t('general.attachments')
					"
					width="100%"
					height="600px"
					class="border border-gray-200 rounded-lg"
				/>
			</div>
		</div>
		<div
			v-else
			class="flex flex-col items-center justify-center gap-2 py-16 text-center border border-gray-200 rounded-lg text-neutral-500 bg-neutral-50"
		>
			<div
				class="flex items-center justify-center w-12 h-12 rounded-full bg-neutral-100"
			>
				<IconFile
					:size="24"
					:aria-hidden="true"
					class="text-grey-700"
				/>
			</div>
			<p class="m-0 text-lg font-medium text-neutral-800">
				{{ $t('general.no-attachments-available') }}
			</p>
			<p class="m-0 text-sm">
				{{ $t('general.applicant-no-attachments-uploaded') }}
			</p>
		</div>
	</div>
</template>

<script>
import IconFile from '~/components/Icons/IconFile'
import Spinner from '~/components/ui/common/Spinner'
import Select from '~/components/ui/form/Select'

export default {
	components: { IconFile, Spinner, Select },
	props: {
		attachments: { type: Array, default: () => [] },
		loading: { type: Boolean, default: false },
		value: { type: Number, default: null }
	},
	computed: {
		attachmentOptions() {
			return this.attachments.map((attachment, index) => ({
				value: index,
				label: attachment.name
			}))
		},
		selection: {
			get() {
				return this.value
			},
			set(value) {
				this.$emit('input', Number(value))
			}
		},
		selectedAttachment() {
			return (
				this.attachments[this.value ?? 0] || this.attachments[0] || null
			)
		}
	}
}
</script>
